/* eslint-disable react-hooks/exhaustive-deps */
import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
// import axiosInstance from "../../config/axios.config";
// import { handleError } from "../../utils/functions";
import { useTranslation } from "react-i18next";

const RatingFilter = ({ index, filters, setFilters }) => {
  return (
    <div className="rating-filter">
      {" "}
      {/* Updated class name */}
      <div className="rating-input">
        <input
          checked={filters.rating === index}
          id={index.toString()}
          name="rating"
          onChange={() => setFilters((prev) => ({ ...prev, rating: index }))}
          type="radio"
        />
        <p className="rating-index">{index}</p>
        <Icon icon="tabler:star-filled" className="rating-icon" />
      </div>
      <div className="rating-bar">
        <div className="rating-fill" style={{ width: `${index * 20}%` }}></div>
      </div>
    </div>
  );
};

const ShopFilters = ({ setFilters, filters }) => {
  const { t } = useTranslation();
  let [active, setActive] = useState(false);
  let sidebarController = () => {
    setActive(!active);
  };

  return (
    <div className="col-lg-12">
      <div className={`shop-sidebar ${active && "active"}`}>
        <button
          onClick={sidebarController}
          type="button"
          className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
        >
          <i className="ph ph-x" />
        </button>
        <div className="row">
          <div className="col-md-4">
            <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
              <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">{t("shopsSearch")}</h6>
              <div className="searchInput">
                <input
                  type="search"
                  placeholder={t("searchShops")}
                  value={filters.name}
                  onChange={(e) => setFilters((prev) => ({ ...prev, name: e.target.value }))}
                />
                <Icon icon="ic:baseline-search" />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
              <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">{t("filterByRating")}</h6>
              {[5, 4, 3, 2, 1].map((item) => (
                  <RatingFilter key={item} index={item} filters={filters} setFilters={setFilters} />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopFilters;
